<template>
<div class="content-footer">
  <!-- SITE GUIDE TOP BUTTON -->
  <div class="site-guide"><router-link :to="{ name: 'SiteGuide'}" title="Site Guide ReShaping">Site Guide</router-link></div>
  <!-- SITE GUIDE TOP BUTTON -->
  <div id="phmGlobalFooter" class="jxp-footer-content">Loading Global Footer... </div>
</div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      msg: 'Newton Website'
    }
  },
  mounted() {
    var globalFooterConfig = {
      "folder" : "global-un-footer",
      "lastupdated": "December 2024",
      "cpcode": "cp-174122v4",
      "color": "red",
       "site-footer-menu": {
      "visible": true,
      "override": true,
      "items": {
        "ContactUs": {
          "menu": true,
          "text": "Contact us",
          "url": "/#/Contact_Us"
        },
         "SiteMap": {
          "menu": true,
          "text": "Site map",
          "url": "/#/Site_Map"
        }
      }
    }
    };
    var site_domain = window.location.href;
    var environment = (site_domain.indexOf("iexpress.itrinno.com") >= 0 || site_domain.indexOf("iexpress.jnj.com") >= 0 || site_domain.indexOf('localhost') >=0 ||
     site_domain.indexOf('dev.reshapingschizophreniacare.com') >=0) ? "stage" : "prod";
    phmLoadGlobalFooter("phmGlobalFooter", "hcp", environment, "www.reshapingschizophreniacare.com", globalFooterConfig);
     this.$nextTick(function () {
      new Promise(resolve => setTimeout(resolve, 1000)).then(() => {
        const link = document.querySelector('.cookie-policy');
        if (link) {
          link.setAttribute('href', '/#/cookie-policy');
        }
      });
    })
  },
}


function topFunction() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

</script>

<style scoped>

body{
line-height: 1.1;
}

a{ display: inline-block }

.content-footer{
  display: flex;
  justify-content: center;
}

#phmGlobalFooter{
    max-width: 1185px;
    margin: 0 auto;
    display: block;
}
  
footer{
  color: #363636;
  font-family: acumin-pro, sans-serif;
  font-size: 14px;
  margin: 27px auto 25px auto;
  width: 1121px;
}

strong{
  font-weight: bold;
}

.footer-wrap{
  position: relative;
}

footer ul{
  display: inline-block;  
  position: absolute;
  width: 950px;
}

footer li{
  display: inline-block;
  line-height: 70px;
  padding-right: 30px;
  vertical-align: top;
  
}

footer p {
  margin-bottom: 25px;
}

footer a{
  color: #363636;
}

footer .footer-logo{
  position: absolute;
  right: 0;
}

footer span{
  padding-right: 20px
}

.top-link{
  background: url(../img/icon-backToTop.png) no-repeat center right;
  color: #A65103;
  font-family: GothamMedium, sans-serif;
  font-size: 18px;
  position: absolute;
  margin-top: -60px;
  right: 115px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  line-height: 42px;
  padding-right: 56px;
}
  
.top-link.show {
  visibility: visible;
  opacity: 1;
}

.top-link.hide {
  visibility: hidden;
  opacity: 0;
}

.site-guide {
  background-color: #144183;
  border-radius: 0 0 20px 20px;
  color: #ffffff;
  font-family: GothamBook, sans-serif;
  font-weight: bold;
  height: 29px;
  line-height: 29px;
  position: absolute;
  right: 126px;
  text-align: center;
  top: 0;
  width: 128px; 
}
.site-guide a{
  color: #ffffff;
  text-decoration: none;
}

.living-site-wrap{
  background-color: #f1f1f6;
  border-radius: 0 0 0 40px;
  display: none;
  height: 398px;
  left: 25%;
  line-height: 29px;
  position: fixed;
  text-align: center;
  top: 15%;
  width: 688px; 
  z-index: 10000;
}

.living-site-wrap.open{
  display: block !important;
}



.living-close{
  background: url(../img/icon-close.png) no-repeat center right;
  cursor: pointer;
  font-size: 0;
  height: 25px;
  margin: 29px 37px 0 0;
  position: absolute;
  right: 0;
  width: 30px;
}

.living-title{
  color: #001151;
  font-family: GothamBook, sans-serif;
  font-size: 36px;
  line-height: 36px;
  margin: 72px 0 0 0;
  padding: 0 55px 9px 55px;
}

.living-text{
  color: #636363;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  line-height: 20px;
  padding: 0 55px;
}

.living-text a{
  color: #001151;
}

.living-button{
  background: rgb(1,168,229);
  background: linear-gradient(90deg, rgba(1,168,229,1) 0%, rgba(27,117,188,1) 80%, rgba(27,117,188,1) 100%);
  border: 0;
  border-radius: 0 0 0 40px;
  bottom: 0;
  color: #ffffff;
  font-size: 22px;
  height: 66px;
  left: 0;
  line-height: 55px;
  position: absolute;  
  width: 100%;   
}

.overlay{
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 2;
  cursor: pointer; 
}



@supports (-webkit-touch-callout: none) {

  .menu li a{
    text-decoration: overline;
  }


  * p{
    display:grid;
  }

  .top-banner h2, .top-banner section p, .bottom-banner, .bottom-banner{
    display: grid;
  }

  .bottom-banner {
    line-height: 23px;
    margin-left: 0;
  }

  .step-circle {
    margin: 60px auto 45px;
}

}


@media screen and (max-width: 1230px){ 
  footer .footer-logo{
    left: 73%;
  }

  footer, footer ul{
    width: 90%;
  }


}

@media screen and (max-width: 880px){

  footer{
    width: 87%;
  }

  footer span:first-child{
    display: block;
  }

  footer ul{
    position: unset;
    width: 100%;
  }

  footer li{
    width: 19%;
  }
  footer li:nth-child(2n){
    width: 50%;
  }

  footer .footer-logo{
    position: unset;
  }

  .site-guide{
    display: none;
  }

  .top-link{
    background-size: 24%;
    font-family: "GothamBook", sans-serif;
    font-size: 13px;
    margin-top: 30px;
    right: 10px;
    line-height: 42px;
    padding-right: 34px;
  }

  .top-banner header .logo img{
    width: 50%;
    max-width: 95%;
  }

  .site-guide{
    display: none;
  }

}
@media screen and (max-width: 415px){
  footer li{
      width: 40%;
    }
  .cp-code{
    white-space:nowrap;
  }
}
@media screen and (max-width: 380px){
  .cp-code{
    padding-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue